module.exports = __webpack_public_path__ + "static/media/home-icon.9228d058.svg";